// extracted by mini-css-extract-plugin
module.exports = {"log":"aK8Kq","pre":"VRaez"};